import { useState } from 'react';
import styles from './styles.module.css';
import { CarAllocation } from '../../../../types/carAllocation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDown,
  faAngleUp,
  faLocationDot,
  faTag,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import CollectionConstraintTypeTag from '../../../../components/common/CollectionConstraintTypeTag';
import { formatTime } from '../../../../services/formatTime';
import { getNumberString } from '../../../../services/getNumberString';

/**
 * 分(数値)を時:分(文字列)に変換する
 * @param minutes number
 * @returns string
 */
const minutesToTime = (minutes: number) => {
  const MINUTES_IN_HOUR = 60 as const;
  const hours = `${Math.floor(minutes / MINUTES_IN_HOUR)}`;
  const restMinutes = `${minutes % MINUTES_IN_HOUR}`.padStart(2, '0');
  return `${hours}:${restMinutes}`;
};

type RowProps = {
  formData: CarAllocation;
  id: number;
};
const LocationDetail = ({ formData, id }: RowProps) => {
  const [isOpened, setIsOpened] = useState(false);

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const getAlphabet = () => {
    return alphabet.substring(id - 1, id);
  };

  let componentColor;
  switch (formData.workCategory.id) {
    case 1: // 回収
      componentColor = styles.blue;
      break;
    case 2: // 処分
      componentColor = styles.yellow;
      break;
    case 3: // 積込
      componentColor = styles.lightYellow;
      break;
    case 4: // 保管
      componentColor = styles.lightBlue;
      break;
    default:
      componentColor = styles.green;
  }

  const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    formData.companyAddress
  )}`;

  const contractDetails = () => {
    if (formData.memo) {
      if (isOpened) {
        return '契約内容を非表示(申し送りあり)';
      } else {
        return '契約内容を表示(申し送りあり)';
      }
    } else {
      if (isOpened) {
        return '契約内容を非表示';
      } else {
        return '契約内容を表示';
      }
    }
  };

  return (
    <div className={classNames(styles.component, componentColor)}>
      <div className={styles.circle}>{getAlphabet()}</div>
      <div className={styles.detail}>
        <div className={styles.detailTop}>
          <div className={styles.time}>
            {formatTime(formData.workStartTime)}
          </div>
          <div>{id === 1 ? '出発' : '到着予定'}</div>
          <a href={href} className={styles.map}>
            <FontAwesomeIcon icon={faLocationDot} className={styles.mapIcon} />
            <div className={styles.mapText}>MAP</div>
          </a>
        </div>
        <div className={styles.destination}>
          <div className={styles.destinationText}>{formData.companyName}</div>
          <CollectionConstraintTypeTag
            type={formData.collectionConstraintType}
          />
        </div>
        {formData.specificTimeStartAt && (
          <div className={styles.isDesignation}>
            <FontAwesomeIcon icon={faTag} className={styles.tagIcon} />
            <div className={styles.isDesignationText}>指定あり</div>
            <div className={styles.isDesignationDate}>
              {formatTime(formData.specificTimeStartAt) +
                '-' +
                formatTime(formData.specificTimeEndAt ?? '')}
            </div>
          </div>
        )}
        <div className={styles.openLocationDetail}>
          <button
            className={styles.showLocationDetailButton}
            onClick={() => {
              setIsOpened(!isOpened);
            }}
          >
            <FontAwesomeIcon
              icon={isOpened ? faAngleUp : faAngleDown}
              className={styles.updownIcon}
            />
            <div className={classNames(styles.isRemarks)}>
              <div className={classNames(styles.isRemarksText)}>
                {contractDetails()}
              </div>
            </div>
          </button>
        </div>
        {!isOpened ? (
          <div className={styles.underBar} />
        ) : (
          <div className={styles.locationDetail}>
            {formData.companyAddress && (
              <div className={styles.address}>{formData.companyAddress}</div>
            )}
            {formData.workCategory.id !== 5 &&
            formData.workCategory.id !== 6 ? (
              <>
                {formData.workCategory.name && (
                  <div className={styles.collect}>
                    <div className={styles.collectText}>
                      {formData.workCategory.name}
                    </div>
                    <div className={styles.collectTime}>
                      {minutesToTime(formData.taskEstimatedTime)}
                    </div>
                  </div>
                )}
                {formData.wasteItems.length !== 0 && (
                  <div className={styles.wasteItems}>
                    {formData.wasteItems.map((c) => (
                      <div key={c.id} className={styles.wasteItemText}>
                        {c.name}
                        {c.collectedAmount && (
                          <>
                            <div className={styles.collectedAmount} />
                            {`${
                              c.collectedAmount > 0 ? '+' : ''
                            }${getNumberString(c.collectedAmount)}㎥`}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {formData.picName && (
                  <div className={styles.pic}>
                    <div className={styles.picName}>{formData.picName}様</div>
                    <div className={styles.picPhoneNumber}>
                      ({formData.picPhoneNumber})
                    </div>
                  </div>
                )}
                <div className={styles.underBar} />
                {formData.memo && (
                  <>
                    <div className={styles.remarks}>
                      <div className={styles.remarksTitle}>申し送り</div>
                      <div>{formData.memo}</div>
                    </div>
                    <div className={styles.underBar} />
                  </>
                )}
              </>
            ) : (
              <div className={styles.underBar} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationDetail;
